<div class="grid-x grid-margin-x">
  <div class="cell">
    <label>Start another work flow:</label>
  </div>
  <div class="cell small-12">
    <label>
      Organization Id Rule:
      <input type="text" [(ngModel)]="seConfiguration.organizationId" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      New Flow Template Id:
      <input type="text" [(ngModel)]="seConfiguration.templateId" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Current Flow Id Context Target:
      <input type="text" [(ngModel)]="seConfiguration.currentTemplateIdPath" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      New Flow Id Context Target:
      <input type="text" [(ngModel)]="seConfiguration.newTemplateIdPath" />
    </label>
  </div>
  <div class="cell small-12">
    <div class="checkbox">
      <input class="show-for-sr" id="chkMultiple" type="checkbox" [(ngModel)]="seConfiguration.startMultipleWorkflows" />
      <label for="chkMultiple">
        <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Start Multiple Workflows based on a Rule
      </label>
    </div>
  </div>
  @if (seConfiguration.startMultipleWorkflows) {
    <div class="cell small-12">
      Rule to determine how many other flows to start. <br />  To work correctly, this rule needs to evaluate to a whole number.
    </div>
    <div class="cell small-12">
      <rules-editor placeholder="# of Flows Rule" [type]="'Number of Flows Rule'" [expression]="seConfiguration.numberOfWorkflowsRule" (updateRule)="multipleFlowsRuleUpdated($event)"></rules-editor>
    </div>
    <div class="cell small-12">
      The rule <span class="bold">must</span> be tested to be successfully attached to the side effect!
    </div>
  }

  <div class="cell small-12">
    <div class="switch tiny">
      <label class="switch-label inline" for="startAtSummary">Should New Flow Start User at Summary Page?:</label>
      <input class="no-margin-bottom vertical-align-middle" type="checkbox" [checked]="seConfiguration.startAtSummary" id="startAtSummary"
        (change)="isStartAtSummaryChanged($event.target.checked)" />
      </div>
    </div>
    <div class="cell small-12">
      <div class="flex-x">
        <h3>Context Rules</h3>
        <button class="margin-left-20px button small" (click)="addContextTransform()">Add Rule</button>
      </div>
      <p>
        The following rules will be ran with the resultant being placed into the new workflow's context.
      </p>
      @if (seConfiguration.startMultipleWorkflows) {
        <p>
          Any transforms included here will apply equally to all started workflows.
        </p>
      }
    </div>
    @for (transform of contextTransforms; track transform; let isLast = $last) {
      <div class="cell small-12">
        <div class="grid-x">
          <div class="cell small-12 flex-x flex-end">
            <input type="text" placeholder="Context Location" [(ngModel)]="transform.contextTarget"/>
            <button class="margin-left-20px button small" (click)="removeContextTransform(transform)">Remove</button>
          </div>
          <rules-editor class="cell small-12" [rule]="transform.rule" placeholder="Transform" type="Context Transform"></rules-editor>
        </div>
        @if (!isLast) {
          <div class="horizontal-rule"></div>
        }
      </div>
    }
  </div>